import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import Unauthorized from "../components/auth/unauthorized.component";
import PERMISSIONS from "../permissions/Permissions";
import { AuthContextType, useAuth } from "../provider/AuthProvider";

interface AuthorizationProps {
  permissions: PERMISSIONS[];
}

const Authorization = ({ permissions }: AuthorizationProps) => {
  const { user } = useAuth() as AuthContextType;
  const location = useLocation();
  if (user && user.permissions) {
    const userpermission = user.permissions;
    const isAllowed = permissions.some((allowed) =>
      userpermission.includes(allowed)
    );
    return isAllowed ? <Outlet /> : <Unauthorized />;
  }
  return <Navigate to='/sign-in' state={{ path: location.pathname }} replace />;
};

export default Authorization;
